import { BaseError } from 'make-error';

export class MissingToken extends BaseError {
    constructor(message?: string) {
        super(message);
    }
}
